import { relations } from 'drizzle-orm'
import { pgTable } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'
import { customJsonb } from './custom-types'
import { Contracts } from './contracts'
import { Organizations } from './organizations'
import { timestamps } from './shared'
import { Users } from './users'
import { generateId } from './utils'

const ContractHistoryChangesSchema = z.record(
  z.object({
    from: z.unknown().nullable().optional(),
    to: z.unknown().nullable().optional()
  })
)

export const ContractHistory = pgTable('contract_history', (t) => ({
  id: t
    .text()
    .primaryKey()
    .$defaultFn(() => generateId(12)),
  contractId: t
    .text('contract_id')
    .notNull()
    .references(() => Contracts.id, { onDelete: 'cascade' }),
  orgId: t
    .text('org_id')
    .notNull()
    .references(() => Organizations.id, { onDelete: 'cascade' }),
  updatedBy: t
    .text('updated_by')
    .notNull()
    .references(() => Users.id, { onDelete: 'restrict' }),
  changedFields: customJsonb(
    'changed_fields',
    ContractHistoryChangesSchema
  ).notNull(),
  ...timestamps
}))

export type ContractHistoryRecord = typeof ContractHistory.$inferSelect
export type ContractHistoryInsert = typeof ContractHistory.$inferInsert

export const insertContractHistorySchema =
  createInsertSchema(ContractHistory)
export const selectContractHistorySchema =
  createSelectSchema(ContractHistory)

export const contractHistoryRelations = relations(
  ContractHistory,
  ({ one }) => ({
    contract: one(Contracts, {
      fields: [ContractHistory.contractId],
      references: [Contracts.id]
    }),
    organization: one(Organizations, {
      fields: [ContractHistory.orgId],
      references: [Organizations.id]
    }),
    updatedBy: one(Users, {
      fields: [ContractHistory.updatedBy],
      references: [Users.id]
    })
  })
)
